export default function initFiltersProducts() {
    if (!document.body.classList.contains('tax-categoria-produto')) return;

    const filtersAside = document.querySelector('.c-filters');
    const openBtn = document.querySelector('.c-grid-area__mobile-toggle');
    const closeBtn = document.querySelector('.c-filters__close');
    const applyBtn = document.querySelector('.c-filters__apply');
    const clearBtns = document.querySelectorAll('.c-filters__clear');
    const accordionBtns = document.querySelectorAll('.c-filters__accordion-btn');
    const tabBtns = document.querySelectorAll('.c-filters__tab-btn');
    const panels = document.querySelectorAll('.c-filters__panel');
    const filterInputs = document.querySelectorAll('.c-filter-item input');
    const countDisplay = document.querySelector('.js-filter-count');
    const aspContainer = document.querySelector('.c-grid-area__asp-hidden');

    // Novo container das pílulas
    const pillsContainer = document.querySelector('.c-filters__active-pills');

    if (!filtersAside || !aspContainer) return;

    // --- FUNÇÕES NUCLEARES ---

    const fetchFilteredResults = async (url) => {
        const gridContainer = document.querySelector('#pdr-ajax-content');
        if (!gridContainer) return;

        gridContainer.style.opacity = '0.5';

        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error('Erro na requisição Fetch');

            const htmlText = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlText, 'text/html');

            const newGrid = doc.querySelector('#pdr-ajax-content');
            if (newGrid) {
                gridContainer.innerHTML = newGrid.innerHTML;
            }
        } catch (error) {
            console.error('Falha ao atualizar o grid via fetch:', error);
        } finally {
            gridContainer.style.opacity = '1';
        }
    };

    const updateURL = () => {
        const url = new URL(window.location);
        for (let key of Array.from(url.searchParams.keys())) {
            if (key.startsWith('termset[')) url.searchParams.delete(key);
        }
        document.querySelectorAll('.c-filter-item input:checked').forEach(input => {
            url.searchParams.append(input.name, input.value);
        });
        window.history.pushState({}, '', url);
    };

    const updateFilterCount = () => {
        const checkedCount = document.querySelectorAll('.c-filter-item input:checked').length;
        if (countDisplay) countDisplay.textContent = checkedCount;
    };

    const syncWithASP = (input, triggerChange = true) => {
        const value = input.value;
        const match = input.name.match(/termset\[(.*?)\]/);
        const taxSlug = match ? match[1] : input.name.replace('termset_', '').replace('[]', '');

        let aspInput = aspContainer.querySelector(`input[name*="${taxSlug}"][value="${value}"]`);
        if (!aspInput) {
            const aspTaxContainer = aspContainer.querySelector(`[class*="${taxSlug}"]`);
            if (aspTaxContainer) aspInput = aspTaxContainer.querySelector(`input[value="${value}"]`);
        }

        if (aspInput) {
            aspInput.checked = input.checked;
            if (triggerChange) {
                aspInput.dispatchEvent(new Event('input', { bubbles: true }));
                aspInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    };

    // --- NOVA LÓGICA: PÍLULAS ATIVAS ---
    const renderActivePills = () => {
        if (!pillsContainer) return;

        pillsContainer.innerHTML = '';
        const checkedInputs = document.querySelectorAll('.c-filter-item input:checked');

        if (checkedInputs.length === 0) {
            pillsContainer.style.display = 'none'; // Esconde o padding se não houver pílulas
            return;
        }

        pillsContainer.style.display = ''; // Retorna ao display: flex do SCSS

        checkedInputs.forEach(input => {
            // Tenta resgatar o texto amigável do filtro (Label)
            const labelEl = input.closest('.c-filter-item') || input.parentElement;

            // Oculta contadores do texto da pílula, se houver span com classe de contador (ex: .count)
            // Caso sua estrutura HTML seja diferente, pegamos o textContent genérico.
            let pillText = input.value;
            if (labelEl) {
                // Clonamos o label para manipular o texto sem alterar o DOM real
                const clone = labelEl.cloneNode(true);
                const countSpan = clone.querySelector('span.count') || clone.querySelector('.c-filter-item__count');
                if (countSpan) countSpan.remove();

                pillText = clone.textContent.trim();
            }

            const pill = document.createElement('div');
            pill.className = 'c-active-pill';
            pill.innerHTML = `
                <span class="c-active-pill__text">${pillText}</span>
                <button type="button" class="c-active-pill__remove" aria-label="Remover filtro" data-name="${input.name}" data-value="${input.value}">&times;</button>
            `;
            pillsContainer.appendChild(pill);
        });

        // Eventos dos botões "X"
        const removeBtns = pillsContainer.querySelectorAll('.c-active-pill__remove');
        removeBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const name = e.currentTarget.getAttribute('data-name');
                const value = e.currentTarget.getAttribute('data-value');
                const originalInput = document.querySelector(`.c-filter-item input[name="${name}"][value="${value}"]`);

                if (originalInput) {
                    originalInput.checked = false; // Desmarca o checkbox real
                    syncWithASP(originalInput, true); // Sincroniza
                    updateFilterCount(); // Atualiza contador do menu
                    updateURL(); // Limpa da URL
                    renderActivePills(); // Destrói a pílula clicada

                    // Refaz a busca IMEDIATAMENTE (comporta-se como o checkbox no desktop)
                    fetchFilteredResults(window.location.toString());
                }
            });
        });
    };

    // --- EVENTOS DE UI ---

    const toggleBodyScroll = (lock) => {
        document.documentElement.style.overflow = lock ? 'hidden' : '';
        document.body.style.overflow = lock ? 'hidden' : '';
        document.body.style.touchAction = lock ? 'none' : '';
    };

    accordionBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            if (window.innerWidth < 992) return;
            const panel = btn.closest('.c-filters__panel');
            btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') !== 'true');
            panel.classList.toggle('is-open');
        });
    });

    openBtn?.addEventListener('click', () => {
        filtersAside.setAttribute('aria-hidden', 'false');
        openBtn.setAttribute('aria-expanded', 'true');
        toggleBodyScroll(true);
    });

    const closeFilters = () => {
        filtersAside.setAttribute('aria-hidden', 'true');
        openBtn?.setAttribute('aria-expanded', 'false');
        toggleBodyScroll(false);
    };

    closeBtn?.addEventListener('click', closeFilters);

    tabBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const targetId = btn.getAttribute('aria-controls');
            tabBtns.forEach(b => {
                b.classList.remove('c-filters__tab-btn--active');
                b.setAttribute('aria-selected', 'false');
            });
            panels.forEach(p => p.classList.remove('c-filters__panel--active'));
            btn.classList.add('c-filters__tab-btn--active');
            btn.setAttribute('aria-selected', 'true');
            document.getElementById(targetId)?.classList.add('c-filters__panel--active');
        });
    });

    // Evento de Change Principal dos Checkboxes
    filterInputs.forEach(input => {
        input.addEventListener('change', () => {
            syncWithASP(input, true);
            updateFilterCount();
            updateURL();
            renderActivePills(); // <- Renderiza as pílulas na hora

            // No desktop, busca automaticamente. No mobile, aguarda o botão aplicar.
            if (window.innerWidth >= 992) {
                fetchFilteredResults(window.location.toString());
            }
        });
    });

    // Botão Aplicar (Mobile)
    applyBtn?.addEventListener('click', () => {
        // Dispara a busca baseada na URL já construída
        fetchFilteredResults(window.location.toString());
        closeFilters();
    });

    // Botão Limpar Todos
    clearBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            let hasChanges = false;
            filterInputs.forEach(input => {
                if (input.checked) {
                    input.checked = false;
                    syncWithASP(input, true);
                    hasChanges = true;
                }
            });

            updateFilterCount();
            updateURL();
            renderActivePills(); // <- Limpa todas as pílulas

            if (hasChanges) {
                fetchFilteredResults(window.location.toString());
            }
        });
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && filtersAside.getAttribute('aria-hidden') === 'false') {
            closeFilters();
        }
    });

    // --- CARREGAMENTO INICIAL ---
    const initLoadState = () => {
        let hasChecked = false;
        const urlParams = new URLSearchParams(window.location.search);

        filterInputs.forEach(input => {
            if (urlParams.getAll(input.name).includes(input.value)) {
                input.checked = true;
                hasChecked = true;
                syncWithASP(input, false);
            }
        });

        if (hasChecked) {
            updateFilterCount();
            renderActivePills(); // <- Se veio carregado de um F5, renderiza

            filterInputs.forEach(input => {
                if (input.checked) {
                    const panel = input.closest('.c-filters__panel');
                    if (panel && !panel.classList.contains('is-open')) {
                        panel.classList.add('is-open');
                        const btn = panel.querySelector('.c-filters__accordion-btn');
                        if (btn) btn.setAttribute('aria-expanded', 'true');
                    }
                }
            });
        }
    };

    initLoadState();
}